import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import CommonImage from '@components/CommonImage';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { useOnboardingStatus } from '@store/reducers/supplier-onboarding/OnboardingReducer';

import { addRejectedField, removeRejectedField } from '@services/supplierOnboardingService';

import { supplierWorkflowFieldList } from '@/constants/constant';

const RejectField = ({ name, stepName }) => {
	const { id } = useParams();
	const dispatch = useDispatch();
	const onboardingStatus = useOnboardingStatus();

	const onRejectClick = async () => {
		try {
			dispatch(openLoader());
			await dispatch(addRejectedField(id, { fieldName: name, step: stepName }));
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const onRemoveRejectClick = async () => {
		try {
			dispatch(openLoader());
			const selectedStepFields = supplierWorkflowFieldList[stepName];
			let existingList = onboardingStatus?.rejectedFieldList?.filter((item) =>
				selectedStepFields.includes(item)
			);
			let postData = { fieldName: name };
			if (existingList.length === 1 && existingList[0] === name) {
				postData['step'] = stepName;
			}
			await dispatch(removeRejectedField(id, postData));
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	return (
		<>
			{!onboardingStatus?.rejectedFieldList?.includes(name) &&
				onboardingStatus?.supplierOnboardingStatus !== 'REJECTED' && (
					<div className="cursor-pointer remove-icon">
						<img
							src={`${process.env.PUBLIC_URL}/icons/cross-box.svg`}
							width={24}
							alt=""
							onClick={onRejectClick}
						/>
					</div>
				)}
			{onboardingStatus?.rejectedFieldList?.includes(name) && (
				<div className="cursor-pointer remove-icon info-icon">
					<CommonImage
						src="/icons/supplierInfo.svg"
						width={24}
						alt=""
						onClick={onRemoveRejectClick}
					/>
				</div>
			)}
		</>
	);
};

export default RejectField;
